export default {
  eventAction: 'monitorEventTrackingCreate',
  pageEventType: 'pv',
  btnEventType: 'cl',
  allCarListPage: { id: 'logistics_allCarList_page', dec: '全部车辆列表' },
  allCarListShowTrackBtn: { id: 'logistics_allCarList_showTrack_btn', dec: '全部车辆列表查看位置' },
  orderCarListPage: { id: 'logistics_orderCarList_page', dec: '接单车辆列表' },
  orderCarListShowTrackBtn: { id: 'logistics_allCarList_showTrack_btn', dec: '接单车辆列表查看轨迹' },
  orderCarListShowMapBtn: { id: 'logistics_orderCarList_showMap_btn', dec: '接单车辆列表地图模式' },
  orderCarMapShowLoadAddressBtn: {
    id: 'logistics_orderCarMap_showLoadAddress_btn',
    dec: '接单车辆地图模式查看装卸货地址'
  },
  orderCarMapShowYellowListBtn: { id: 'logistics_orderCarMap_showYellowList_btn', dec: '接单车辆地图模式只看黄名单' },
  orderCarMapShowTrackBtn: { id: 'logistics_orderCarMap_showTrack_btn', dec: '接单车辆地图模式查看轨迹' },
  orderCarMapSearchBtn: { id: 'logistics_orderCarMap_search_btn', dec: '接单车辆地图模式搜索' },
  abnormalTrackPage: { id: 'logistics_abnormalTrack_page', dec: '轨迹异常明细列表' },
  abnormalTrackShowTrackBtn: { id: 'logistics_abnormalTrack_showTrack_btn', dec: '轨迹异常明细列表查看轨迹' },
  abnormalTrackAddPlateYellowBtn: {
    id: 'logistics_abnormalTrack_addPlateYellow_btn',
    dec: '轨迹异常明细列表车辆加入黄名单'
  },
  abnormalTrackAddDriverYellowBtn: {
    id: 'logistics_abnormalTrack_addDriverYellow_btn',
    dec: '轨迹异常明细列表司机加入黄名单'
  },
  orderDtlMapPage: { id: 'logistics_orderDtlMap_page', dec: '轨迹详情' },
  orderDtlMapAddDriverYellowBtn: { id: 'logistics_orderDtlMap_addDriverYellow_btn', dec: '轨迹详情司机加入黄名单' },
  orderDtlMapAddPlateYellowBtn: { id: 'logistics_orderDtlMap_addPlateYellow_btn', dec: '轨迹详情车辆加入黄名单' },
  orderDtlMapShowParkBtn: { id: 'logistics_orderDtlMap_showPark_btn', dec: '轨迹详情查看停车点' },
  drivingControlPage: { id: 'logistics_drivingControl_page', dec: '行车监控概况' },
  abnormalCommonSettingPage: { id: 'logistics_abnormalCommonSetting_page', dec: '监控设置通用设置' },
  abnormalAlertSettingPage: { id: 'logistics_abnormalAlertSetting_page', dec: '监控设置通知设置' },
  abnormalCommonSettingSaveBtn: { id: 'logistics_abnormalCommonSetting_save_btn', dec: '监控设置通用设置保存' },
  abnormalAlertSettingSaveBtn: { id: 'logistics_abnormalAlertSetting_save_btn', dec: '监控设置通知设置保存' },
  notifyDriveBtn: { id: 'logistics_home_notifyDriver_btn', dec: '物流圈顶部消息一键通知司机' }, // 物流圈-顶部消息 一键通知司机
  showParkDetailBtn: { id: 'logistics_home_viewDetail_btn', dec: '物流圈顶部消息无定位消息查看' } // 物流圈-顶部消息 无定位消息查看
};
